import { useContext, useState, useEffect } from 'react';

import AuthContext from '../../store/AuthContext';
import CopyButton from '../widgets/CopyButton';

function AuthMd() {
  const iuaCtx = useContext(AuthContext);

  const authMd = iuaCtx.authMd;
  const [serverMd, setServerMd] =  useState(''); 

  // TODO empty
  let mdData = '';
  let mdDataEmpty = 'No data found';

  useEffect(() => {
    const md = JSON.stringify(authMd, null, 2);
    setServerMd(md);
  }, []);

  function GetMD() {
    if (authMd) {
      try {
        mdData = JSON.stringify(authMd, null, 2);
      } catch(error) {
        console.error("could not parse server metadata", error);
      }
    }
    // TODO error handling, empty, CopyButton
    return mdData || mdDataEmpty;
  }
  
  const mdDataDisplay = 
  <p>
    <span className="code-line"><GetMD></GetMD></span>
  </p>

  return (
    <div className="card card-body code-block success" title="Authorization Server Metadata">
      <div className="main-form-output white-text"> 
        <pre>{mdDataDisplay}</pre>
        {/* {serverMd && serverMd !== '{}' && <CopyButton position='top-right' data={serverMd}></CopyButton>} */}
        <CopyButton data={serverMd}></CopyButton>
      </div>
    </div>
  );
}

export default AuthMd;
